import { render, staticRenderFns } from "./eventodds.vue?vue&type=template&id=c13a3436&scoped=true"
import script from "./eventodds.vue?vue&type=script&lang=js"
export * from "./eventodds.vue?vue&type=script&lang=js"
import style0 from "./eventodds.vue?vue&type=style&index=0&id=c13a3436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13a3436",
  null
  
)

export default component.exports